import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
} from '@material-ui/core'
import { HelpOutline } from '@material-ui/icons'
import Spoiler from '../Spoiler'
import { removePunctuation } from '../../../lib/util'
import { PHRASES_BY_LANG } from '../../../lib/constants'

const VideoReviewCard = ({ sentences, translationLang }) => {
  const [isOpen, setOpen] = useState(false)

  const handleOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }
  return (
    <Paper elevation={1} style={{ padding: 24, marginTop: 24 }}>
      <Typography align="center" variant="h5">
        {`${PHRASES_BY_LANG.weakWords[translationLang]}`}
        <IconButton onClick={handleOpen}><HelpOutline /></IconButton>
      </Typography>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography>{`${PHRASES_BY_LANG.word[translationLang]}`}</Typography>
              </TableCell>
              <TableCell>
                <Typography>{`${PHRASES_BY_LANG.sentence[translationLang]}`}</Typography>
              </TableCell>
              <TableCell>
                <Typography>{`${PHRASES_BY_LANG.translation[translationLang]}`}</Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sentences.map((sentence, index) => (
              <TableRow key={index}>
                <TableCell component="th" scope="row">
                  <Typography>{sentence.word.word}</Typography>
                </TableCell>
                <TableCell>
                  {
                    sentence.content.split(' ').map((word, idx) => (
                      <span key={idx}>
                        <span
                          style={{ borderBottom: removePunctuation(word).toLowerCase() === sentence.word && '1px black solid' }}
                        >
                          {word}
                        </span>
                        {idx !== (sentence.content.length - 1) && <span>{' '}</span>}
                      </span>
                    ))
                  }
                </TableCell>
                <TableCell>
                  <Spoiler text={sentence.translation} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Dialog
        open={isOpen}
        onClose={handleClose}
      >
        <DialogTitle>{`${PHRASES_BY_LANG.listTooltip.title[translationLang]}`}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {`${PHRASES_BY_LANG.listTooltip.body[translationLang]}`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            {`${PHRASES_BY_LANG.close[translationLang]}`}
          </Button>
        </DialogActions>
      </Dialog>
    </Paper>
  )
}

VideoReviewCard.propTypes = {
  sentences: PropTypes.arrayOf(PropTypes.object),
  translationLang: PropTypes.string,
}

VideoReviewCard.defaultProps = {
  sentences: [],
  translationLang: 'en',
}

export default VideoReviewCard
